/**
 * @generated SignedSource<<fbf4869eb3eca6e0e24ef8fa295cba56>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type plusArticleTypeTitleContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"helpersGetArticleTypeArticle">;
  readonly " $fragmentType": "plusArticleTypeTitleContent";
};
export type plusArticleTypeTitleContent$key = {
  readonly " $data"?: plusArticleTypeTitleContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"plusArticleTypeTitleContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "plusArticleTypeTitleContent",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersGetArticleTypeArticle",
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ArticleTypeSegment",
              "kind": "LinkedField",
              "name": "types",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ArticleType",
                  "kind": "LinkedField",
                  "name": "value",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entityId",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "Article",
          "abstractKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "37e681aed37ae6d4b4371f5af235a13e";

export default node;
